const PRIORITIES = [
    { id: 0, nombre: 'Baja', extraClass: 'baja-prioridad' },
    { id: 1, nombre: 'Media', extraClass: 'media-prioridad' },
    { id: 2, nombre: 'Alta', extraClass: 'alta-prioridad' }
]

export {PRIORITIES};